<template>
  <div class="page-wrapper">
    <button class="page-title" @click="emit('goDealMainPage')">
      <Icons name="PrevPagination" color="#242424" size="lg" />
      Toplu Komisyon Teklifi Yönetimi
    </button>
    <div class="page-content">
      <div class="action-boxes">
        <ActionBox
          :index="1"
          box-type="download"
          :offer-period-start="startDate"
          :offer-period-end="finishDate"
          img="bulk-download@2x.png"
          title="Komisyon Teklifi Şablonu Oluştur"
          text="İlgili tarihlerdeki avantajlı komisyon tekliflerinden faydalanmak veya tekliflerden toplu olarak vazgeçmek için şablon oluşturun."
          btn-text="Şablon İndir"
        />
        <ActionBox
          :index="2"
          box-type="upload"
          :offer-period-start="startDate"
          :offer-period-end="finishDate"
          img="bulk-upload@2x.png"
          title="Şablon Dosyasını Yükle"
          text="Doldurduğunuz şablonu yüklemek için dosyayı bilgisayarınızdan seçin veya bu alana sürükleyip bırakın."
          btn-text="Dosya Seç"
          warning-text="Dosya .xls formatında ve en fazla 25 MB boyutunda olmalıdır."
          v-on:refresh-table="refreshTable"
        />
      </div>
      <div class="tab-wrapper">
        <button
          :class="['tab-btn', { active: activeTab === 'template-table' }]"
          @click="activeTab = 'template-table'"
        >
          Şablon İndirme Geçmişim
        </button>
        <button
          :class="['tab-btn', { active: activeTab === 'file-table' }]"
          @click="activeTab = 'file-table'"
        >
          Dosya Yükleme Geçmişim
        </button>
      </div>
      <BulkDealTable v-if="activeTab === 'template-table'" table-type="template-table" />
      <BulkDealTable v-if="activeTab === 'file-table'" table-type="file-table" />
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { Icons } from "@n11/so-ui-components";
import ActionBox from "./partials/ActionBox.vue";
import BulkDealTable from "./partials/BulkDealTable.vue";

const emit = defineEmits(['goDealMainPage'])

const props = defineProps({
  startDate: {
    type: String,
    required: false,
    default: '',
  },
  finishDate: {
    type: String,
    required: false,
    default: '',
  }
})

const activeTab = ref('template-table');
const refreshRef = ref(null)
const refreshTable = (e) => {
  activeTab.value = e.tab
  refreshRef.value = e;
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.page-wrapper {
  width: 100%;

  .page-title {
    font-size: 20px;
    font-weight: 700;
    letter-spacing: -0.2px;
    color: $colorN80;
    display: flex;
    align-items: center;
    padding: 16px 0;
  }

  .page-content {
    background-color: $colorN00;
    padding: 34px 24px;
    
    .action-boxes {
      display: flex;
      gap: 24px;
      margin-bottom: 24px;
    }

    .tab-wrapper {
      display: flex;
      gap: 12px;

      .tab-btn {
        padding: 7px 12px;
        border: 0.5px solid $colorD30;
        border-radius: 6px;
        font-size: 13px;
        font-weight: 600;
        color: $colorN80;

        &.active {
          background-color: $colorM05;
          border: 2px solid $colorM50;
        }
      }
    }
  }
}
</style>